import { AbstractAnalyticalTool, AbstractBehavioralTool } from '../../../components/consent-modal/types';
import { MixpanelTool } from './mixpanel';
import { StatsigTool } from './statsig';

export const BEHAVIORAL_TOOLS: AbstractBehavioralTool[] = [new MixpanelTool(), new StatsigTool()];
export const ANALYTICS_TOOLS: AbstractAnalyticalTool[] = [];

export const ALL_TOOLS = [...BEHAVIORAL_TOOLS, ...ANALYTICS_TOOLS];